export default __webpack_public_path__ + "static/media/me.01bf97cb.png";